// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__1GofZ","header":"ClearentDisclaimer_header__p3PeV","inner":"ClearentDisclaimer_inner__3DHxT"};